import React from 'react';
import { Item } from './styles';
import { formatTimestamp } from './utils';

export default function PicoState({ data }) {
  if (!data) return null;

  return (
    <Item>
      <h3 style={{ marginBlockEnd: 0 }}>Pico state</h3>
      {Object.entries(data).map(([sensor_id, d]) => (
        <div key={d.id || d.timestamp}>
          {formatTimestamp(d.timestamp)}
          <p style={{ marginLeft: '1em' }}>
            {`Motor controller: ${d.motor_controller}`}<br />
            {`Motor enable: ${d.motor_enable}`}<br />
            Resistors: {d.lr_0 ? '1' : '0'}{d.lr_1 ? '1' : '0'}{d.lr_2 ? '1' : '0'}{d.lr_3 ? '1' : '0'}{d.lr_4 ? '1' : '0'}<br />
          </p>
        </div>
      ))}
    </Item>
  );
}
